site.hamburger = {
	selector: '#hamburger',

	init: function () {
		site.hamburger.bind();
		// site.hamburger.appendLanguage();
		// site.hamburger.appendQuickNav();
	},

	bind: function () {
		// Mobile menu toggle
		$('#hamburgerToggle').on('click touchstart', function (e) {

			e.stopPropagation();
			e.preventDefault();

			var menuOpen = $('body').hasClass('hamburger-open');
			site.hamburger.hamburgerToggle(e, menuOpen);

			if (!menuOpen) {
				$(this).attr('aria-expanded', true);
			}
			else {
				$(this).removeAttr('aria-expanded');
			}

			$(site.hamburger.selector).on('click touchstart', function (e) {
				e.stopPropagation();
			});

			var body = $('body.hamburger-open');
			body.on('click touchstart', function () {
				$('body').removeClass('hamburger-open');
			});
			body.keyup(function(e){
				if(e.key === 'Escape'){
					$('body').removeClass('hamburger-open');
				}
			});
		});
	},
	// Toggle mobile menu
	hamburgerToggle: function (e, menuOpen) {
		$('body').toggleClass('hamburger-open');
	},

	// Append language to site
	appendLanguage: function () {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', site.hamburger.selector);

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function () {
			var $li = $(this).clone();
			$html.append($li.find('a'));
		});

		$menu.append($html);
	},

	appendQuickNav: function () {
		var $qn = $('#qn');
		var $menu = $('ul.mmLevel1', site.hamburger.selector);
		var $qnContent = '';

		$qn.find('li').each(function () {
			$qnContent += '<li class="qn level1">' + $(this).clone().html() + '</li>';
		});
		$menu.append($qnContent);
	}
};

site.inits.push('site.hamburger.init()');
